import { render, staticRenderFns } from "./ContractWidget.vue?vue&type=template&id=3d944eb4&"
import script from "./ContractWidget.vue?vue&type=script&lang=js&"
export * from "./ContractWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d944eb4')) {
      api.createRecord('3d944eb4', component.options)
    } else {
      api.reload('3d944eb4', component.options)
    }
    module.hot.accept("./ContractWidget.vue?vue&type=template&id=3d944eb4&", function () {
      api.rerender('3d944eb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/ContractWidget.vue"
export default component.exports